import { paramValidatorError } from './errors';
import { getRequiredVariables } from '../types';
export var requiredVariablesValidatorError = paramValidatorError('itemData', "must have required variables, for example: { \"slug\": \"shoes\" }");
export var requiredVariablesValidator = function (key, itemData) {
    try {
        var required = getRequiredVariables(key);
        if (!required.every(function (requiredVariable) {
            return Boolean(itemData[requiredVariable]);
        }) ||
            !required.length) {
            throw new Error();
        }
    }
    catch (e) {
        return requiredVariablesValidatorError;
    }
};
//# sourceMappingURL=required-variables-validator.js.map